
  import {Vue} from "vue-property-decorator";
  import Component from "vue-class-component";
  import { DateTime } from "luxon";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  import router from "../../router";
  import FormEdit from "./FormEdit.vue"
import { Alert } from "@/addons/Alert";
  
  @Component({
    name: "PacientesIndex",
    components: {FormEdit}
  })
  export default class PacientesIndex extends Vue {
    
    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
    public swEditar = false;
    paciente_selected = null;
    fecha = DateTime.now().toFormat('yyyy-MM-dd');
    
    public fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
    public fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
    $refs!: {
      form: HTMLFormElement,
    };
    public txtSearch = "";
    mounted(){
      this.getPacientes();
    }
    getPacientes(){
      this.loading
      let data = {
        page: this.pagination.current_page,
        txtSearch: this.txtSearch
      }
      this.consultorioService.getPacientesSearch(data)
    }
    nuevo(){
      router.push({name: 'nuevo-paciente'});
    }
    editar(paciente:any){
      this.swEditar = true;
      this.paciente_selected = paciente;
    }
    eliminar(paciente:any) {
      Alert.confirm(`Eliminar al paciente ${paciente.nombre_completo}`, 'Eliminar paciente?').then(res => {
        if (res.isConfirmed) {
          this.consultorioService.eliminarPaciente(paciente.id);
          this.getPacientes();
        }
      })
    }
        
    get datos(): any {
      return this.consultorioStore.pacientes;
    }
    get pagination(): any {
      return this.consultorioStore.pagination;
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }
  }
  